let loadingCount = 0;

function normalizeRejection(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === 'string') {
    return new Error(error);
  }

  return new Error('Route loading action failed', { cause: error });
}

function incrementRouteLoadingAnimation() {
  loadingCount = loadingCount + 1;
  document.body.dataset.loading = '';
}

function decrementRouteLoadingAnimation() {
  loadingCount = loadingCount - 1;
  setTimeout(() => {
    if (loadingCount <= 0) delete document.body.dataset.loading;
  }, 50);
}

/**
 * Defer action to later and start showing a loading animation to reduce INP
 */
export async function deferWithLoadingAnimation(
  fn: () => void | Promise<void>,
) {
  incrementRouteLoadingAnimation();

  return new Promise<void>((resolve, reject) => {
    // Perform action on the next event loop to avoid blocking the main thread before
    // the animation is executed
    // oxlint-disable-next-line @typescript-eslint/no-misused-promises
    setTimeout(async () => {
      try {
        await fn();
        resolve();
      } catch (error) {
        reject(normalizeRejection(error));
      } finally {
        decrementRouteLoadingAnimation();
      }
    }, 1);
  });
}

export function deferWithBriefLoadingAnimation(fn: () => unknown) {
  incrementRouteLoadingAnimation();
  setTimeout(() => fn(), 1);
  setTimeout(() => decrementRouteLoadingAnimation(), 300);
}
